module.exports = __webpack_public_path__ + "assets/img/00033.7525b38f.png";